<template>
    <div itemscope itemtype='http://schema.org/Vehicle'>

        <social-media-meta :object='object'></social-media-meta>

        <div class='row'>
            <div class='col-md-2 hidden-print'></div>
            <div class='col-md-10'>
                <h1 :itemprop="meta(object._index, 'title')">{{object.searchable.title[0]}}</h1>
            </div>
        </div>

        <div v-for='property in object.order'>
            <div v-if='object[property.column]'>

                <!-- All non custom properties -->
                <noncustom-prop :object='object'
                    v-if='ignored.indexOf(property.column) == -1'
                    :metatag="meta(object._index, property.column)"
                    :property='property'>
                </noncustom-prop>

                <!-- Vessel Type  -->
                <span v-if='property.column == "gen_fld1"'>
                    <noncustom-prop :object='object'
                        :property='property'
                        :metatag="meta(object._index, property.column)"
                        link='searchable-vessel_type-keyword'>
                    </noncustom-prop>
                </span>

                <!-- Builder  -->
                <span v-if='property.column == "gen_fld7"'>
                    <noncustom-prop :object='object'
                        :property='property'
                        :metatag="meta(object._index, property.column)"
                        link='searchable-actors-keyword'>
                    </noncustom-prop>
                </span>

                <!-- Record Date -->
                <div class='row' v-if='property.column == "custom_record_date"'>
                    <div class='col-md-2 hidden-print'></div>
                    <div class='col-md-3'><strong>{{property.label}}</strong></div>
                    <div class='col-md-7' :itemprop="meta(object._index, property.column)">
                        {{formatDate(object, 'custom_record_date')}}
                    </div>
                </div>
            </div>

            <!-- Related -->
            <div class='row' v-if='property.column == "custom_related" && hasNonAssociationRelations(object.relation_count)'>
                <div class='col-md-2 hidden-print'></div>
                <div class='col-md-3'><strong>{{property.label}}</strong></div>
                <div class='col-md-7'>
                    <related :object='object'></related>
                </div>
            </div>

            <!-- Associations -->
            <div class='row' v-if='property.column == "custom_associations" &&
                    object.relation_count.parent &&
                    object.relation_count.parent.association'>
                <div class='col-md-2 hidden-print'></div>
                <div class='col-md-3'><strong>{{property.label}}</strong></div>
                <div class='col-md-7'>
                    <a :href="generateLink({'indices': 'association', 'child-keyword': object._id})">
                        {{object.relation_count.parent.association}} Associations
                    </a>
                </div>
            </div>

            <!-- Media -->
            <detail-media :object='object' :property='property'></detail-media>
        </div>
    </div>
</template>

<script>
    import manageProperties from './../../mixins/manageProperties.js'
    import manageRelations from './../../mixins/manageRelations.js'
    import manageMetatags from './../../mixins/manageMetatags.js'
    import ViewRelated from './../../mixins/viewRelated.js'
    import SocialMediaMetaVue from './parts/socialMediaMeta.vue'
    import RelatedVue from './parts/related.vue'
    import NoncustomVue from './parts/noncustom.vue'
    import MediaVue from './detailMedia.vue'

    export default {
        mixins: [manageProperties, manageRelations, manageMetatags, ViewRelated],
        props: ['object'],
        components: {
            'noncustom-prop': NoncustomVue,
            'detail-media': MediaVue,
            'related': RelatedVue,
            'social-media-meta': SocialMediaMetaVue
        },
        data: function () {
            return {
                ignored: [
                    'gen_id',
                    'gen_fld1',
                    'gen_fld7',
                    'custom_related',
                    'custom_record_date'
                ],
            }
        }
    }
</script>
